import styled from 'styled-components';

/** Keeps the rolling digits tabular so the odometer tween doesn't shift the
 *  centred gauge layout, and lets the figure inherit the gauge's font size. */
export const Root = styled.span`
  display: inline-flex;
  font-variant-numeric: tabular-nums;
`;
